import { Box } from "@chakra-ui/react"

import { useDAppRoute, useHodlRoute } from "#/shared/hooks"
import PortalData from "#/ui-old/PortalData"

import BaseFooter from "./BaseFooter"

export default function Footer() {
  const isDAppRoute = useDAppRoute()
  const isHodlPage = useHodlRoute()

  if (!isDAppRoute) return null

  return (
    <Box h={isHodlPage ? "131px" : "60px"} w="100%" pos="relative" zIndex={70}>
      {isHodlPage ? <PortalData /> : <BaseFooter />}
    </Box>
  )
}
